"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var isEmpty = require('lodash/isEmpty');

var uniq = require('lodash/uniq');

var Product = require('./Product');

var PaperProduct = /*#__PURE__*/function (_Product) {
  _inherits(PaperProduct, _Product);

  var _super = _createSuper(PaperProduct);

  function PaperProduct() {
    var _this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PaperProduct);

    _this = _super.call(this, params);
    _this.ink_colors = uniq(params.ink_colors) || [];
    _this.letterpress_ink_colors = uniq(params.letterpress_ink_colors) || [];
    _this.ink_color = params.ink_color || 'Black';
    _this.accent_color = params.accent_color || 'Black';
    _this.border_color_a = params.border_color_a || 'Black';
    _this.border_color_b = params.border_color_b || 'Black';
    _this.design_name = params.design_name || 'Poppy';
    _this.paper_type = params.paper_type || 'White Matte';
    _this.color_notes = params.color_notes || null;
    return _this;
  } // get name() {
  //     return this.catalog_entry.name;
  // }


  _createClass(PaperProduct, [{
    key: "colors",
    get: function get() {
      return uniq([].concat(_toConsumableArray(this.ink_colors), _toConsumableArray(this.letterpress_ink_colors))).filter(function (a) {
        return a;
      });
    }
  }, {
    key: "colorsUsed",
    value: function colorsUsed() {
      var colors = isEmpty(this.ink_colors) ? ['Black'] : this.ink_colors;
      this.components.forEach(function (component) {
        if (component.liner_color && component.liner_style === 'classic') {
          colors.push(component.liner_color);
        }

        if (component.wrapper_color) {
          colors.push(component.wrapper_color);
        }
      });
      return uniq(colors);
    }
  }, {
    key: "letterpressColorsUsed",
    value: function letterpressColorsUsed() {
      return this.letterpress_ink_colors || [];
    }
  }, {
    key: "requires_custom_postage",
    get: function get() {
      return this.components.some(function (comp) {
        return comp.custom_postage;
      });
    }
  }, {
    key: "requires_guest_addressing",
    get: function get() {
      return this.components.some(function (comp) {
        return comp.guest_addressing;
      });
    }
  }, {
    key: "requires_name_printing",
    get: function get() {
      return this.components.some(function (comp) {
        return comp.name_printing;
      });
    }
  }]);

  return PaperProduct;
}(Product);

module.exports = PaperProduct;